<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
    <div>
        <loading :active.sync="isLoading" :is-full-page="true" loader="dots" :height="150" :width="150" color="#ff5900"></loading>
        <CForm @submit.prevent="">
            <CTabs>
                <CTab title="Evento" active>
                    <CRow>
                        <CCol sm="12">
                            <!--pre>
                                {{evento}}
                            </pre-->
                            <CCard>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="4">
                                            <CInput label="Nombre *" v-model="evento.nombre" :is-valid="validar($v.evento.nombre)"/>
                                        </CCol>
                                        <CCol sm="8">
                                            <CInput label="Descripción" v-model="evento.descripcion"/>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="authData.user.idPerfil == 1">
                                        <CCol sm="12">
                                            <CSelect label="Campus *" @change="obtenerCatalogos" :options="campus" :value.sync="evento.idCampus" :is-valid="validar($v.evento.idCampus)"/>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="4">
                                            <CSelect label="Tipo de evento *" :disabled="tiposEvento.length == 1" :options="tiposEvento" :value.sync="evento.idTipoEvento" :is-valid="validar($v.evento.idTipoEvento)"/>
                                        </CCol>
                                        <CCol sm="4">
                                            <CSelect label="Categoría *" :disabled="categoriasEvento.length == 1" :options="categoriasEvento" :value.sync="evento.idCategoriaEvento" :is-valid="validar($v.evento.idCategoriaEvento)"/>
                                        </CCol>
                                        <CCol sm="4">
                                            <CSelect label="Área organizadora *" :disabled="areas.length == 1" :options="areas" :value.sync="evento.idArea" :is-valid="validar($v.evento.idArea)"/>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="4">
                                            <CInput type="number" v-model="evento.costo" value="0" label="Costo *" :is-valid="validar($v.evento.costo)"/>
                                        </CCol>
                                        <CCol sm="4">
                                            <CSelect :label="'Forma de pago ' + (evento.costo > 0 ? '*' : '')" :options="formasDePagoEvento" :value.sync="evento.idFormaPagoEvento"
                                            :disabled="evento.costo < 1" :is-valid="validar($v.evento.idFormaPagoEvento)"/>
                                        </CCol>
                                        <CCol sm="4">
                                            <CInput type="number" v-model="evento.cupoMaximo" value="0" label="Cupo máximo *" :is-valid="validar($v.evento.cupoMaximo)"/>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="fechaInicio">Fecha de Inicio *</label>
                                                <date-picker v-model="evento.fechaInicio" type="date" :input-class="'form-control' + claseValida($v.evento.fechaInicio)" valueType="format" :input-attr="{ id: 'fechaInicio'}"></date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="horaInicio">Hora de Inicio *</label>
                                                <date-picker v-model="evento.horaInicio" type="time" :input-class="'form-control' + claseValida($v.evento.horaInicio)" valueType="format" :input-attr="{ id: 'horaInicio'}" :show-second="false">
                                                    <i slot="icon-calendar">
                                                        <font-awesome-icon icon="clock" />
                                                    </i>
                                                </date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="fechaFin">Fecha de Fin *</label>
                                                <date-picker v-model="evento.fechaFin" type="date" :input-class="'form-control' + claseValida($v.evento.fechaFin)" valueType="format" :input-attr="{ id: 'fechaFin'}"></date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="horaFin">Hora de Fin *</label>
                                                <date-picker v-model="evento.horaFin" type="time" :input-class="'form-control' + claseValida($v.evento.horaFin)" valueType="format" :input-attr="{ id: 'horaFin'}" :show-second="false">
                                                    <i slot="icon-calendar">
                                                        <font-awesome-icon icon="clock" />
                                                    </i>
                                                </date-picker>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="fechaInicioInscripcion">Fecha Inicio Inscripción *</label>
                                                <date-picker v-model="evento.fechaInicioInscripcion" type="date" :input-class="'form-control' + claseValida($v.evento.fechaInicioInscripcion)" valueType="format" :input-attr="{ id: 'fechaInicioInscripcion'}"></date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="horaInicioInscripcion">Hora Inicio Inscripción *</label>
                                                <date-picker v-model="evento.horaInicioInscripcion" type="time" :input-class="'form-control' + claseValida($v.evento.horaInicioInscripcion)" valueType="format" :input-attr="{ id: 'horaInicioInscripcion'}" :show-second="false">
                                                    <i slot="icon-calendar">
                                                        <font-awesome-icon icon="clock" />
                                                    </i>
                                                </date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="fechaFinInscripcion">Fecha Fin Inscripción *</label>
                                                <date-picker v-model="evento.fechaFinInscripcion" type="date" :input-class="'form-control' + claseValida($v.evento.fechaFinInscripcion)" valueType="format" :input-attr="{ id: 'fechaFinInscripcion'}"></date-picker>
                                            </div>
                                        </CCol>
                                        <CCol sm="6" md="3">
                                            <div role="group" class="form-group">
                                                <label for="horaFinInscripcion">Hora Fin Inscripción *</label>
                                                <date-picker v-model="evento.horaFinInscripcion" type="time" :input-class="'form-control' + claseValida($v.evento.horaFinInscripcion)" valueType="format" :input-attr="{ id: 'horaFinInscripcion'}" :show-second="false">
                                                    <i slot="icon-calendar">
                                                        <font-awesome-icon icon="clock" />
                                                    </i>
                                                </date-picker>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <!-- Comentado temporalmento sub eventos -->
                                    <!--CRow>
                                        <CCol sm="4">
                                                <CSwitch v-bind="labelIcon" id="eventoVirtual" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.eventoVirtual = 1 : evento.eventoVirtual = 0"
                                                :checked="evento.eventoVirtual == 1" value="1"/>
                                                Es un evento virtual
                                        </CCol>
                                        <CCol sm="4">
                                                <CSwitch v-bind="labelIcon" id="tieneSubeventos" :color="'success'" variant="3d"
                                                @update:checked="(val) => tabSubEventos(val)"
                                                :checked="evento.tieneSubeventos == 1" value="1"/>
                                                Contiene sub-eventos
                                        </CCol>   
                                        <CCol sm="4">
                                                <CSwitch v-bind="labelIcon" id="inscripcionIndividual" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.inscripcionIndividual = 1 : evento.inscripcionIndividual = 0"
                                                :checked="evento.inscripcionIndividual == 1" value="1" :disabled="evento.tieneSubeventos == 0"/>
                                                Registro individual a sub-eventos
                                        </CCol>
                                    </CRow-->
                                    <CRow class="mt20">
                                        <CCol sm="6" md="8">
                                            <CRow>
                                                <CCol sm="12">
                                                    <CRow>
                                                        <CCol sm="4">
                                                                <CSwitch v-bind="labelIcon" id="eventoVirtual" :color="'success'" variant="3d"
                                                                @update:checked="(val) => val ? evento.eventoVirtual = 1 : evento.eventoVirtual = 0"
                                                                :checked="evento.eventoVirtual == 1" value="1"/>
                                                                Es un evento virtual
                                                        </CCol>
                                                        <CCol sm="8">
                                                            <CInput :label="'Enlace del evento Virtual ' + (evento.eventoVirtual ? '*' : '')" v-model="evento.urlVirtual" :disabled="!evento.eventoVirtual"
                                                            invalid-feedback="Campo requerido" placeholder="Ejemplo: https://www.mieventovirtual.mx"
                                                            :is-valid="validar($v.evento.urlVirtual)"/>
                                                        </CCol>
                                                        
                                                    </CRow>
                                                </CCol>
                                                <CCol sm="12">
                                                    <div role="group" class="form-group">
                                                        <label for="acUbicacion">Lugar de ubicación {{(!evento.eventoVirtual ? '*' : '')}}</label>
                                                        <input :class="'autocomplete form-control' + claseValida($v.evento.lugar)" v-model="evento.lugar" id="acUbicacion" :disabled="evento.eventoVirtual == 1" placeholder="Ingrese la ubicación" ref="acUbicacion" type="text">
                                                    </div>
                                                </CCol>
                                                <CCol sm="12">
                                                    <CInput :disabled="evento.eventoVirtual == 1" v-model="evento.sitio" placeholder="Ejemplo: Sala 1 de exhibición" label="Sitio"/>
                                                </CCol>
                                                <CCol sm="12">
                                                     <div role="group" class="form-group">
                                                        <label for="campusShared">
                                                            Evento multicampus
                                                        </label>
                                                        <multiselect id="campusShared" v-model="campusSelected" placeholder="Seleccione uno o más campus Anáhuac" deselectLabel="Presione enter para eliminar" 
                                                        selectLabel="Presione enter para seleccionar" 
                                                        selectedLabel="Seleccionado" @input="campusIds"
                                                        :custom-label="campusName"  
                                                        track-by="value" :options="campus" :multiple="true"></multiselect>
                                                     </div>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol sm="6" md="4">
                                            <img-upload field="img"
                                                @crop-success="cropSuccess"
                                                v-model="showUploadImg"
                                                :noCircle="true"
                                                :width="720"
                                                :height="360"
                                                langType="es-MX"
                                                img-format="jpg"></img-upload>
                                            <img :src="(evento.imagen != '' && evento.imagen != null ? evento.imagen : imgGenerico) + vImg" class="img-fluid" alt="Imagen evento">
                                            <CButton color="primary" size="sm" :block="true" class="mb15" @click="toggleShow">
                                                <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" /> Cargar Imagen    
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="6" md="3">
                                                <CSwitch v-bind="labelIcon" id="visible" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.visible = 1 : evento.visible = 0"
                                                :checked="evento.visible == 1" value="1"/>
                                                Visible para búsqueda
                                        </CCol>   
                                        <CCol sm="6" md="3">
                                                <CSwitch v-bind="labelIcon" id="permiteInscripcion" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.permiteInscripcion = 1 : evento.permiteInscripcion = 0"
                                                :checked="evento.permiteInscripcion == 1" value="1"/>
                                                Permitir Inscripción
                                        </CCol>
                                        <CCol sm="6" md="3">
                                                <CSwitch v-bind="labelIcon" id="permiteCancelar" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.permiteCancelar = 1 : evento.permiteCancelar = 0"
                                                :checked="evento.permiteCancelar == 1" value="1"/>
                                                Permitir desinscripción
                                        </CCol>
                                        <CCol sm="6" md="3">
                                                <CSwitch v-bind="labelIcon" id="permiteCheckOut" :color="'success'" variant="3d"
                                                @update:checked="(val) => val ? evento.permiteCheckOut = 1 : evento.permiteCheckOut = 0"
                                                :checked="evento.permiteCheckOut == 1" value="1" :disabled="evento.eventoVirtual == 1"/>   
                                                Evento con Check-out
                                        </CCol>   
                                        <CCol sm="6" md="3">
                                            <CSwitch v-bind="labelIcon" id="requiereCalificacion" :color="'success'" variant="3d"
                                            @update:checked="(val) => val ? evento.requiereCalificacion = 1 : evento.requiereCalificacion = 0"
                                            :checked="evento.requiereCalificacion == 1" value="0"/>   
                                                Alumno requiere calificar
                                        </CCol>   
                                    </CRow>
                                    <alert-advertencia v-if="advertencia" class="mt20" :msgAdvertencia="msgAdvertencia"></alert-advertencia>    
                                    <alert-exito v-if="exito" class="mt20" :msgExito="msgExito"></alert-exito>    
                                </CCardBody>
                                <CCardFooter>
                                    <CButton color="success" type="button" @click="guardarDatos" size="sm" class="float-right" :disabled="enviandoDatos">
                                        <font-awesome-icon :icon="['fas', 'save']" /> Guardar    
                                    </CButton>
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CTab>
                <CTab v-show="evento.tieneSubeventos" title="Sub-eventos">
                    <CRow>
                        <CCol sm="12">
                            <CCard>
                                <CCardBody>
                                    <CRow>
                                        <CCol sm="12">
                                            <CButton color="primary" class="float-right mb15" @click="agregarSubevento()">
                                                <font-awesome-icon :icon="['fas', 'plus']" /> 
                                                Agregar nuevo 
                                            </CButton>
                                        </CCol>
                                    </CRow>
                                    <!--pre>
                                    {{subeventos}}
                                    </pre-->
                                    <div class="card" v-for="(sub, i) in subeventos" :key="i" :set="v = $v.subeventos.$each[i]">
                                        <div class="card-header bg-light">
                                            <span>Sub-evento: {{sub.nombre}}</span>
                                            <button type="button" v-if="i > 1" class="btn btn-pill btn-danger float-right" @click="eliminarSubEvento(sub)">
                                                <font-awesome-icon :icon="['fas', 'trash-alt']" /> 
                                            </button>
                                        </div>
                                        <div class="card-body">
                                            <CRow>
                                                <CCol sm="4">
                                                    <CInput label="Nombre *" v-model="sub.nombre" :is-valid="validar(v.nombre)"/>
                                                </CCol>
                                                <CCol sm="8">
                                                    <CInput label="Descripción" v-model="sub.descripcion"/>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol sm="4">
                                                    <CInput type="number" v-model="sub.costo" value="0" label="Costo *" :is-valid="validar(v.costo)"/>
                                                </CCol>
                                                <CCol sm="4">
                                                    <CSelect :label="'Forma de pago ' + (sub.costo > 0 ? '*' : '')" :options="formasDePagoEvento" :value.sync="sub.idFormaPagoEvento"
                                                    :disabled="sub.costo < 1" :is-valid="validar(v.idFormaPagoEvento)"/>
                                                </CCol>
                                                <CCol sm="4">
                                                    <CInput type="number" v-model="sub.cupoMaximo" value="0" label="Cupo máximo *" :is-valid="validar(v.cupoMaximo)"/>
                                                </CCol>
                                            </CRow>
                                            
                                            <CRow>
                                                <CCol sm="6" md="3">
                                                    <div role="group" class="form-group">
                                                        <label :for="'fechaInicio' + i">Fecha de Inicio *</label>
                                                        <date-picker v-model="sub.fechaInicio" type="date" :input-class="'form-control' + claseValida(v.fechaInicio)" valueType="format" :input-attr="{ id: 'fechaInicio' + i }"></date-picker>
                                                    </div>
                                                </CCol>
                                                <CCol sm="6" md="3">
                                                    <div role="group" class="form-group">
                                                        <label :for="'horaInicio' + i">Hora de Inicio *</label>
                                                        <date-picker v-model="sub.horaInicio" type="time" :input-class="'form-control' + claseValida(v.horaInicio)" valueType="format" :input-attr="{ id: 'horaInicio'}" :show-second="false"></date-picker>
                                                    </div>
                                                </CCol>
                                                <CCol sm="6" md="3">
                                                    <div role="group" class="form-group">
                                                        <label :for="'fechaFin' + i">Fecha de Fin *</label>
                                                        <date-picker v-model="sub.fechaFin" type="date" :input-class="'form-control' + claseValida(v.fechaFin)" valueType="format" :input-attr="{ id: 'fechaFin' + i }"></date-picker>
                                                    </div>
                                                </CCol>
                                                <CCol sm="6" md="3">
                                                    <div role="group" class="form-group">
                                                        <label :for="'horaFin' + i">Hora de Fin *</label>
                                                        <date-picker v-model="sub.horaFin" type="time" :input-class="'form-control' + claseValida(v.horaFin)" valueType="format" :input-attr="{ id: 'horaFin' + i }" :show-second="false"></date-picker>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                           
                                            <CRow>
                                                <CCol sm="4">
                                                    <label :for="'permiteCancelar' + i">
                                                        <CSwitch v-bind="labelIcon" :id="'permiteCancelar' + i" :color="'success'" variant="3d"
                                                        @update:checked="(val) => val ? sub.permiteCancelar = 1 : sub.permiteCancelar = 0"
                                                        :checked="sub.permiteCancelar == 1" value="1"/>
                                                        Permitir cancelación
                                                    </label>
                                                </CCol>
                                                <CCol sm="4">
                                                    <label :for="'permiteCheckOut' + i">
                                                        <CSwitch v-bind="labelIcon" :id="'permiteCheckOut' + i" :color="'success'" variant="3d"
                                                        @update:checked="(val) => val ? sub.permiteCheckOut = 1 : sub.permiteCheckOut = 0"
                                                        :checked="sub.permiteCheckOut == 1" value="1"/>   
                                                        Evento con Check-out
                                                    </label>
                                                </CCol>
                                                <CCol sm="4">
                                                    <label :for="'eventoVirtual' + i">                                            
                                                        <CSwitch v-bind="labelIcon" :id="'eventoVirtual' + i" :color="'success'" variant="3d"
                                                        @update:checked="(val) => val ? sub.eventoVirtual = 1 : sub.eventoVirtual = 0"
                                                        :checked="sub.eventoVirtual == 1" value="1"/>
                                                        Es un evento virtual
                                                    </label>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol sm="12">
                                                    <CInput :label="'Enlace del evento Virtual ' + (sub.eventoVirtual ? '*' : '')" v-model="sub.urlVirtual" :disabled="!sub.eventoVirtual"
                                                    invalid-feedback="Campo requerido" placeholder="Ejemplo: https://www.mieventovirtual.mx"
                                                    :is-valid="validar(v.urlVirtual)"/>
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </div>
                                    <alert-advertencia v-if="advertencia" :msgAdvertencia="msgAdvertencia"></alert-advertencia>    
                                    <alert-exito v-if="exito" :msgExito="msgExito"></alert-exito>    
                                </CCardBody>
                                <CCardFooter v-show="subeventos.length > 0">
                                    <CButton color="success" type="button" @click="guardarDatos" size="sm" class="float-right" :disabled="enviandoDatos">
                                        <font-awesome-icon :icon="['fas', 'save']" /> Guardar    
                                    </CButton>
                                </CCardFooter>
                            </CCard>
                        </CCol>
                    </CRow>
                </CTab>
                <CTab title="Editores">
                    <loading :active.sync="isLoading" :is-full-page="true" loader="dots" :height="150" :width="150" color="#ff5900"></loading>
                    <alert-advertencia v-if="advertencia" :msgAdvertencia="msgAdvertencia"></alert-advertencia>    
                    <alert-exito v-if="exito" :msgExito="msgExito"></alert-exito>    
                    <CCard v-if="!isLoading">
                        <CCardHeader>
                            <CRow class="title">
                                <p>Lista de editores</p>
                                <CButton color="success" type="button" @click="openEditorsFinders"  size="sm" class="float-right" :disabled="enviandoDatos">
                                    <font-awesome-icon :icon="['fas', 'user']" /> Agregar editor    
                                </CButton>
                            </CRow>
                            
                        </CCardHeader>
                        <CCardBody>
                            <CCol>
                                <div class="editor" v-if="editores.length > 0">
                                    <table class="table table-sm table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Correo</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in editores" :key="i">
                                                <td>
                                                    {{item.usuario.nombre}} {{item.usuario.apellidoPaterno}} {{item.usuario.apellidoMaterno}}
                                                </td>
                                                <td>
                                                    {{item.usuario.email}}
                                                </td>
                                                <td>
                                                     <CButton class="btn btn-danger" type="button"  size="sm" @click="removeEditor(i)">
                                                        <font-awesome-icon :icon="['fas', 'trash']" /> 
                                                    </CButton>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </CCol>
                        </CCardBody>
                    </CCard>
                     
                </CTab>
                <CTab title="Calificaciones">
                    <CCard v-if="!isLoading">
                        <CCardHeader>
                            <CRow class="title">
                                <p>Lista de calificaciones de los participantes</p>
                                <CRow align-horizontal="center" align-vertical="center">
                                    <h6 v-if="evento.rating >=0" style="margin: 0">
                                        Calificación global: 
                                        <span v-for="(star, index) in [1,2,3,4,5]" v-bind:key="index">
                                            <font-awesome-icon v-if="star > evento.rating || evento.rating == 0" class="simple-star" :icon="['fa', 'star']"></font-awesome-icon>
                                            <font-awesome-icon v-if="star <= evento.rating && evento.rating > 0" class="yellow-star" :icon="['fas', 'star']"></font-awesome-icon>
                                        </span>
                                    </h6>
                                    <download-excel v-c-tooltip="{content: 'Exportar calificaciones'}"
                                        class="btn btn-success btn-sm ml5"
                                        worksheet="Calificaciones"
                                        name="Calificaciones.xls"
                                        :fetch="fetchData"
                                        :fields="fetchFields()"
                                        :before-generate="startDownload"
                                        :before-finish="finishDownload">
                                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                                    </download-excel>
                                </CRow>
                            </CRow>
                            
                        </CCardHeader>
                        <CCardBody>
                            <CCol>
                                <div class="editor" v-if="calificaciones.length > 0">
                                    <table class="table table-sm table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Rating</th>
                                                <th style="max-width: 250px; white-space: pre-line;" v-for="(value, index) in elementosCalificados" :key="index">
                                                {{ makeReadable(value) }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in calificaciones" :key="i">
                                                <td>
                                                    {{ item.name }}
                                                </td>
                                                <td>
                                                    {{item.rating}}
                                                </td>
                                                <td v-for="(value, index) in elementosCalificados" :key="index">
                                                    {{ item.elements[value] == 1 ? 'Sí' : 'No' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-if="calificaciones.length == 0">
                                    <h3>
                                        No hay registros de calificaciones por parte de los participantes
                                    </h3>
                                </div>
                            </CCol>
                        </CCardBody>
                    </CCard>
                </CTab>
            </CTabs>
        </CForm>
        <CModal :show.sync="openEditorsFinder" 
        @keydown.esc="openEditorsFinder=false;">
                <CRow>
                    <CCol md="12">
                        <cool-select
                            :items="items"
                            :loading="loading"
                            item-text="nombre"
                            placeholder="Escriba para buscar y seleccionar"
                            disable-filtering-by-search
                            @search="onSearch"
                            >
                                <template #no-data>
                                    {{
                                        noData
                                        ? "No se encontraron coincidencias."
                                        : "Escriba más de " + numLetras + " letras para buscar."
                                    }}
                                </template>
                                <template #item="{ item }">
                                    <div class="item" @click="addEditor(item)">
                                        <div>
                                            <span class="item-name">{{ ( item.idAnahuac != null ? '(' + item.idAnahuac + ')' : '') + item.nombre + ' ' + item.apellidoPaterno + ' ' + item.apellidoMaterno }}</span><br />
                                        </div>
                                    </div>
                                </template>

                                <template #input-end>
                                    <!-- You can use your own loading spinner -->
                                    <font-awesome-icon v-if="loading" icon="spinner" pulse/>
                                    <font-awesome-icon v-else icon="search"/>    
                                </template>
                            </cool-select>
                    </CCol>
                    <CCol md="12" v-show="nuevosParticipantes.length > 0">
                        <CCardBody class="table-responsive">
                            <table class="table table-sm table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Correo</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(p, index) in nuevosParticipantes" v-bind:key="index">
                                        <td> {{p.nombre}} {{p.apellidoPaterno}} {{p.apellidoMaterno ? p.apellidoMaterno : ""}}</td>
                                        <td>{{p.email}}</td>
                                        <td style="width:35px">
                                            <CButton size="sm" shape="pill" class="btn btn-danger"  @click="removerParticipante(index)">
                                                <font-awesome-icon :icon="['fas', 'trash']" />    
                                            </CButton>
                                        </td>
                                    </tr> 
                                </tbody>  
                            </table>
                        </CCardBody>
                    </CCol>
                </CRow>
                <div slot="footer">
                    <CButton color="light" class="mr5" size="sm" @click="openEditorsFinder=false;">
                        <font-awesome-icon :icon="['fas', 'times-circle']" /> Cerrar
                    </CButton>
                    <CButton color="success" type="submit" size="sm" class="float-right" @click="registrarEditores" :disabled="guardando">
                        <font-awesome-icon :icon="['fas', 'save']" /> Confirmar    
                    </CButton> 
                </div>   
        </CModal>
    </div>
</template>
<script>
import VueTimepicker from 'vue2-timepicker'
import Multiselect from 'vue-multiselect'
import 'vue2-timepicker/dist/VueTimepicker.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { required, requiredIf, minValue, url } from "vuelidate/lib/validators";
import imgUpload from 'vue-image-crop-upload';
import Loading from 'vue-loading-overlay';
import { CoolSelect } from "vue-cool-select";
import 'vue-loading-overlay/dist/vue-loading.css';
import downloadExcel from "vue-json-excel";

export default {
    name: 'AltaEvento',
    components: { Multiselect, DatePicker, CoolSelect, VueTimepicker, imgUpload, Loading, downloadExcel },
    data () {
        return {
            id: 0,
            campusList: [],
            campusSelected: [],
            isLoading: false,
            labelIcon: {
                labelOn: '\u2713',
                labelOff: '\u2715'
            },
            openEditor: false,
            numLetras: 3,
            basePath: process.env.VUE_APP_API_URL,
            openEditorsFinder: false,
            oUser: this.$AuthApiService.getDataLocalStorage(),
            noData: false,
            loading:false,
            items: [],
            selected: null,
            guardando: false,
            paramsUrl: '?limit=0&activo=1',
            msgError: '',
            msgExito: '',
            msgAdvertencia: '',
            error: false,
            exito: false,
            advertencia: false,
            enviandoDatos: false,
            token: { access_token: null },
            nuevosParticipantes: [],
            saveUser: [],
            evento: {
                idCampus: "",
                idTipoEvento: "",
                idCategoriaEvento: "",
                idArea: "",
                idFormaPagoEvento: "",
                lugar: null,
                costo: 0,
                cupoMaximo: 0,
                tieneSubeventos: 0,
                visible: 1,
                permiteInscripcion: 1,
                inscripcionIndividual: 0,
                permiteCancelar: 1,
                permiteCheckOut: 0,
                eventoVirtual: 0,
                horaInicio: '',
                horaFin: '',
                horaInicioInscripcion: '',
                horaFinInscripcion: '',
                fechaInicioInscripcion:'',
                imagen: '',
                requiereRating: 0
            },
            previousEventData: {
                idCampus: "",
                idTipoEvento: "",
                idCategoriaEvento: "",
                idArea: "",
                idFormaPagoEvento: "",
                lugar: null,
                costo: 0,
                cupoMaximo: 0,
                tieneSubeventos: 0,
                visible: 0,
                permiteInscripcion: 1,
                inscripcionIndividual: 0,
                permiteCancelar: 0,
                permiteCheckOut: 0,
                eventoVirtual: 0,
                horaInicio: '',
                horaFin: '',
                horaInicioInscripcion: '',
                horaFinInscripcion: '',
                fechaInicioInscripcion:'',
                imagen: '',
                requiereRating: 0
            },
            subeventos: [],
            areas: [],
            campus: [],
            tiposEvento: [],
            calificaciones: [],
            elementosCalificados: [],
            categoriasEvento: [],
            formasDePagoEvento: [],
            editores: [],
            showUploadImg: false,
            imgDataUrl: '',
            imgGenerico: '/img/defaultImg.png',
            vImg: '?v=' + Math.random(),
            authData: this.$AuthApiService.getDataLocalStorage(),
            campusParam: '',
            
        }
    },
    validations: {
        evento: {
            nombre: { required },
            costo: { required, minValue: minValue(0) },
            idTipoEvento: { required },
            idCategoriaEvento: { required },
            idCampus: { required },
            idArea: { required },
            idFormaPagoEvento: {
                required: requiredIf(function (eventoModel) {
                    return eventoModel.costo > 0
                })
            },
            cupoMaximo: { required, minValue: minValue(0) },
            fechaInicio: { required },
            horaInicio: { required },
            fechaFin: { required },
            horaFin: { required },
            fechaInicioInscripcion: { required },
            horaInicioInscripcion: { required },
            fechaFinInscripcion: { required },
            horaFinInscripcion: { required },
            permiteInscripcion: { required },
            tieneSubeventos: { required },
            inscripcionIndividual: { required },
            permiteCancelar: { required },
            permiteCheckOut: { required },
            visible: { required },
            eventoVirtual: { required },
            urlVirtual: {
                url,
                required: requiredIf(function (eventoModel) {
                    return eventoModel.eventoVirtual
                })
            },
            lugar: {
                required: requiredIf(function (eventoModel) {
                    return !eventoModel.eventoVirtual
                })
            },
            // requiereRating: { required },
        },
        subeventos: {
            $each: {
                nombre: { required },
                costo: { required, minValue: minValue(0) },
                cupoMaximo: { required, minValue: minValue(0) },
                fechaInicio: { required },
                horaInicio: { required },
                fechaFin: { required },
                horaFin: { required },
                permiteCancelar: { required },
                permiteCheckOut: { required },
                eventoVirtual: { required },
                urlVirtual: {
                    url,
                    required: requiredIf(function (eventoModel) {
                        return eventoModel.eventoVirtual
                    })
                },
            }
        }    
    },
    methods: {
        async onSearch(search) {
            this.noData = false;
            if (search.length < this.numLetras) {
                this.items = [];
                this.loading = false;
                return;
            }
            this.loading = true;

            clearTimeout(this.timeoutId);
            const filtros = { 
                idAnahuac: search,
                nombre: search,
                apellidoPaterno: search,
                apellidoMaterno: search,
                perfil: [1,2,3,5,6]
            };
            const params = '&' + this.queryString(filtros);
            
            this.timeoutId = setTimeout(async () => {
                const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
                const response = await this.$axios.get(this.basePath + 'api/usuarios?limit=10&activo=1' + params, oHeaders);
                this.items = await response.data.data.data;
                this.loading = false;

                if (!this.items.length) this.noData = true;
            }, 500);
        },
        campusName(data) {
            return data.label;
        },
        campusIds() {

            this.campusList = [];

            this.campusSelected.map((item) => {
                this.campusList.push(item.value);
            });
        },
         removerParticipante(indice) {
            this.nuevosParticipantes.splice(indice, 1);
        },
        addEditor(item) {
            this.nuevosParticipantes.push(item);
        },
        async removeEditor(index) {
            const result = await this.$swal({
                title: '¿Estás segur@ de eliminar al editor?',
                text: "",
                icon: 'info', 
                buttons: [
                    'Cancelar',
                    'Sí, eliminar'
                ]
            });
            if (result) {
                this.isLoading = true;
                this.exito = false;
                this.advertencia = false;
                const userId = this.editores[index].usuario.id;
                const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
                const response = await this.$axios.post(this.basePath + 'api/gestores/editores/eliminar',{ 
                    userId: userId,
                    eventId: this.evento.id
                } ,oHeaders);
                console.log(response);
                this.isLoading = false;
                if (response.data) {
                    this.editores.splice(index, 1);
                    this.exito = true;
                    this.msgExito = "Usuario eliminado como editor";
                } else {
                    this.advertencia = true;
                    this.msgAdvertencia = "No pudo eliminarse el editor correctamente. Intente más tarde."
                }
                setTimeout(() => {
                    this.advertencia = false;
                    this.exito = false;
                }, 1000);
                 this.isLoading = false;
            }
        },  
        queryString(obj) {
            var str = [];
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] != '' && obj[p] != null) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            }
            return str.join("&");
        },
        async compartirEvento(id = null) {
            if ((this.evento.id || id)) {

                const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
                const response = await this.$axios.post(this.basePath + 'api/campus/compartir-evento',{ 
                    campusIds: this.campusList,
                    eventId: id ? id: this.evento.id,
                    userUpdated: this.authData.user.id,
                } ,oHeaders);
            }
        },
        async registrarEditores(ignoreClean = false, id = null) {
            this.guardando = true;
           
            if (!ignoreClean) {
                this.saveUser = [];
                this.nuevosParticipantes.map((item) => {
                    this.saveUser.push(item.id);
                });
            }

            if (this.evento.id || id) {
                this.saveUser = [];
                this.nuevosParticipantes.map((item) => {
                    this.saveUser.push(item.id);
                });
                const oHeaders = { headers: { 'Authorization': this.oUser.token_type + ' ' + this.oUser.access_token } };
                const response = await this.$axios.post(this.basePath + 'api/gestores/editores',{ 
                    users: [...this.saveUser],
                    eventId: id ? id: this.evento.id
                } ,oHeaders);

                this.guardando = false;
                if (response.data.success) {
                    this.msgExito = "Se añadieron los editores correctamente";
                    this.exito = true;
                    this.nuevosParticipantes.map((item) => {
                        this.editores.push({
                            usuario: {
                                ...item
                            }
                        });
                    });
                    this.nuevosParticipantes = [];
                    this.saveUser = [];
                    
                } else {
                    this.advertencia = true;
                    this.msgAdvertencia = "Hubo un error al incluir a los editores. Intente más tarde";
                }
                setTimeout(() => {
                    this.advertencia = false;
                    this.exito = false;
                }, 1000);
                
            } else {
                this.msgExito = "No olvides confirmar a los editores. Guardando los datos del evento.";
                this.exito = true;
                this.nuevosParticipantes.map((item) => {
                    this.editores.push({
                        usuario: {
                            ...item
                        }
                    });
                });
            }


            this.nuevosParticipantes = [];
            this.guardando = false;
            this.openEditorsFinder = false;
        },  
        toggleShow() {
			this.showUploadImg = !this.showUploadImg;
		},
        cropSuccess(imgDataUrl){
            this.vImg = '';
            this.evento.imagen = imgDataUrl;
        },
		validar(ev) {
            if (typeof ev != 'undefined' && ev.$dirty) {
                return !ev.$error;
            }
            return
        },
        claseValida(ev) {
            if (typeof ev != 'undefined' && ev.$dirty) {
                return !ev.required ? ' is-invalid' : ' is-valid';
            }
            return '';
        },
        tabSubEventos(val) {
            if (val) {
                this.evento.tieneSubeventos = 1;
                this.agregarSubevento();
                this.agregarSubevento();
            } else {
                this.evento.tieneSubeventos = 0;
                this.subeventos = [];
            }
        },
        openEditorsFinders() {
            this.openEditorsFinder = true;
        },
        guardarDatos() {
            this.$v.$touch();
            if (this.$v.$error) {
                console.log(this.$v);
                return;   
            }
            
            this.isLoading = true;
            this.enviandoDatos = true;
            const datosEvento = Object.assign({}, this.evento);
            if (datosEvento.costo < 1) {
                delete datosEvento.idFormaPagoEvento;
            }
            if (datosEvento.imagen == null) {
                delete datosEvento.imagen;
            }
            if (datosEvento.sitio == '' || datosEvento.sitio == null) {
                delete datosEvento.sitio;
            }
            if (datosEvento.eventoVirtual == 1) {
                delete datosEvento.lugar;
                delete datosEvento.sitio;
                delete datosEvento.latitud;
                delete datosEvento.longitud;
                delete datosEvento.urlMapa;
            }

            if (this.id > 0) {
                this.actualizar(datosEvento);
            } else {
                this.insertar(datosEvento);
            }
        },
        isValidDates(data) {
            const initDate = new Date(data.fechaInicio + ' ' + data.horaInicio);
            const endDate = new Date(data.fechaFin + ' ' + data.horaFin);
            if (initDate.valueOf() >= endDate.valueOf()) {

                return false;
            }

            const initInscript = new Date(data.fechaInicioInscripcion + ' ' + data.horaInicioInscripcion);
            const endInscript = new Date(data.fechaFinInscripcion + ' ' + data.horaFinInscripcion);

            if (initInscript.valueOf() >= endInscript.valueOf()) {
                return false;
            }

            return true;
        },
        showDialog(titleT, msg) {
            this.$swal({
                title: titleT,
                text: msg,
                icon: 'info', 
                buttons: [
                    'Cerrar',
                    'Entendido'
                ]
                });
        },
        insertar(datos) {
            if (!this.isValidDates(datos)) {
                this.showDialog('Incongruencia en fechas', 'Al parecer las fechas asignadas a inscripción/incio de evento no parecen ser congruentes, revise su información.');
                this.isLoading = false;
                this.enviandoDatos = false;
                return;
            }

            datos.usuarioRegistro = this.authData.user.nombre + " " + this.authData.user.apellidoPaterno+ " " + this.authData.user.apellidoMaterno;;
            datos.usuarioActualiza = this.authData.user.nombre + " " + this.authData.user.apellidoPaterno+ " " + this.authData.user.apellidoMaterno;;
            datos.userCreated = this.authData.user.id;
            datos.userUpdated = this.authData.user.id;

            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/eventos', datos, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {

                    if (response.data.error) {
                        this.msgAdvertencia = response.data.error;
                        this.advertencia = true;
                        this.isLoading = false;
                        this.enviandoDatos = false;
                        setTimeout(() => { 
                            this.msgAdvertencia = '';
                            this.advertencia = false;
                        }, 5000);
                        return;
                    }

                    if (this.saveUser.length > 0) {
                        this.registrarEditores(true, response.data.lastInserted);
                    }

                    this.compartirEvento(response.data.lastInserted);
                    this.campusList = [];

                    if (this.subeventos.length > 0) {
                        this.registrarSubEventos(response.data.lastInserted);
                    } else {
                        this.msgExito = response.data.msg;
                        this.isLoading = false;
                        this.exito = true;
                        setTimeout(() => { 
                            this.$router.push('/eventos/listado')
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                    if (typeof error.response.data != 'undefined') {
                        if (typeof error.response.data.msg == 'undefined') {
                            this.msgAdvertencia = error.response.data.message;
                        } else {
                            this.msgAdvertencia = error.response.data.msg;
                        }
                        this.advertencia = true;
                        setTimeout(() => { 
                            this.msgAdvertencia = '';
                            this.advertencia = false;
                        }, 5000);
                    }
                    this.isLoading = false;
                    this.enviandoDatos = false;
                })
            );
        },
        actualizar(datos) {
            console.log(datos);
            if (!this.isValidDates(datos)) {
                this.showDialog('Incongruencia en fechas', 'Al parecer las fechas de inicio y fin de evento no parecen ser congruentes, revise su información.');
                this.isLoading = false;
                this.enviandoDatos = false;
                return;
            }

            datos.usuarioActualiza = this.authData.user.nombre + " " + this.authData.user.apellidoPaterno + " " + this.authData.user.apellidoMaterno;
            datos.userUpdated = this.authData.user.id;

            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.put(this.basePath + 'api/eventos/' + this.id, datos, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {

                    if (response.data.error) {
                        this.msgAdvertencia = response.data.error;
                        this.advertencia = true;
                        this.isLoading = false;
                        this.enviandoDatos = false;
                        setTimeout(() => { 
                            this.msgAdvertencia = '';
                            this.advertencia = false;
                        }, 5000);
                        return;
                    }

                    this.compartirEvento();
                    this.campusList = [];

                    if (this.subeventos.length > 0) {
                        this.registrarSubEventos(0);
                        const typeOfChange = this.$notificationService.detectChangeInEvent(this.previousEventData, datos);

                        if (typeOfChange) {
                            this.$notificationService.updateAndNotifyEventChanges(datos, this.id, typeOfChange);
                        }

                        
                    } else {
                        this.msgExito = response.data.msg;
                        this.isLoading = false;
                        this.exito = true;

                        const typeOfChange = this.$notificationService.detectChangeInEvent(this.previousEventData, datos);

                        if (typeOfChange) {
                            this.$notificationService.updateAndNotifyEventChanges(datos, this.id, typeOfChange);
                        }

                        setTimeout(() => { 
                            this.$router.push('/eventos/listado')
                        }, 3000);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                    if (typeof error.response.data != 'undefined') {
                        if (typeof error.response.data.msg == 'undefined') {
                            this.msgAdvertencia = error.response.data.message;
                        } else {
                            this.msgAdvertencia = error.response.data.msg;
                        }
                        this.advertencia = true;
                        setTimeout(() => { 
                            this.msgAdvertencia = '';
                            this.advertencia = false;
                        }, 5000);
                    }
                    this.isLoading = false;
                    this.enviandoDatos = false;
                })
            );
        },
        alertSelector() {
            return new Promise((resolve, reject) => {
                this.$swal({
                title: '¿Estás segur@ de cancelar al evento?',
                text: "",
                icon: 'info', 
                buttons: [
                    'Regresar',
                    'Sí, Cancelar evento'
                ]
                }).then((result)  => {
                    resolve(result);
                });
            });
           
        },
        async eliminar() {

            const confirmed = await this.alertSelector();
            if (!confirmed)
            return;


            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.delete(this.basePath + 'api/eventos/' + this.id, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    console.log(response.data);
                    if (this.evento) {
                        this.$notificationService.cancelEventComplete({
                            eventId: this.id,
                            isVFI: (this.evento.tipoEvento == "VFI Pass" && this.evento.claveCampus == "UAM")
                        });

                        if (this.evento.requiereCalificacion == 1) {
                            this.$notificationService.removeAllRatingData({
                                event: {
                                    id: this.id,
                                }
                            });
                        }
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        registrarSubEventos(idEvento) {
            for (let i in this.subeventos) {
                if (idEvento > 0) {
                    /*seteo de idEvento cuando es evento nuevo, esto es importante, porque si falla el insert de los subeventos y el evento ya se guardo, 
                    la siguiente peticion sera update, evitando registrar el mismo evento varias veces, y solo registrar los subeventos*/
                    this.id = idEvento;
                    this.subeventos[i].idEvento = idEvento;
                }
                if (this.subeventos[i].costo < 1) {
                    delete this.subeventos[i].idFormaPagoEvento;
                }
                if (this.subeventos[i].eventoVirtual == 0) {
                    delete this.subeventos[i].urlVirtual;
                }
            }
        
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.post(this.basePath + 'api/subeventos', this.subeventos, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.msgExito = response.data.msg;
                    this.isLoading = false;
                    this.exito = true;
                    setTimeout(() => { 
                        this.$router.push('/eventos/listado')
                    }, 3000);
                })
                .catch(error => {
                    console.log(error.response);
                    if (typeof error.response.data != 'undefined') {
                        if (typeof error.response.data.msg == 'undefined') {
                            this.msgAdvertencia = error.response.data.message;
                        } else {
                            this.msgAdvertencia = error.response.data.msg;
                        }
                        this.advertencia = true;
                        setTimeout(() => { 
                            this.msgAdvertencia = '';
                            this.advertencia = false;
                        }, 5000);
                    }
                    this.isLoading = false;
                    this.enviandoDatos = false;
                })
            );
        },
        obtenerCampus() {
            this.campus = [];
            this.campus.push({ value: '', label: '-Selecciona-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/campus' + this.paramsUrl, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        if (listado[key].clave != 'TODAS') {
                            this.campus.push({ value: listado[key].id, label: listado[key].nombre });
                        }
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerAreas() {
            this.areas = [];
            this.areas.push({ value: '', label: '-Selecciona-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/areas' + this.paramsUrl + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        this.areas.push({ value: listado[key].id, label: listado[key].nombre });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerTiposDeEvento() {
            this.tiposEvento = [];
            this.tiposEvento.push({ value: '', label: '-Selecciona-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/tipos-de-evento' + this.paramsUrl + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        this.tiposEvento.push({ value: listado[key].id, label: listado[key].nombre });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerCategoriasEvento() {
            this.categoriasEvento = [];
            this.categoriasEvento.push({ value: '', label: '-Selecciona-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/categorias-evento' + this.paramsUrl + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        this.categoriasEvento.push({ value: listado[key].id, label: listado[key].nombre });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerFormasDePagoEvento() {
            this.formasDePagoEvento = [];
            this.formasDePagoEvento.push({ value: '', label: '-Selecciona-'});
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/formas-pago-evento' + this.paramsUrl + this.campusParam, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    const listado = response.data.data;
                    for (const key in listado) {
                        this.formasDePagoEvento.push({ value: listado[key].id, label: listado[key].nombre });
                    }
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        convertPlaceToFriendlyObject(place) {
			let result = undefined;
			if (place) {
                result = {};
                const l = place.address_components.length;
				for (let i = 0; i < l; i++) {
					if (i == 0) {
						result.searchedBy = place.address_components[i].types[0];
					}
					result[place.address_components[i].types[0]] = place.address_components[i].long_name;
                }
                result.name = place.name;
				result.formattedAddress = place.formatted_address;
				result.lat = place.geometry.location.lat();
				result.lng = place.geometry.location.lng();
				result.mapUrl = place.url;
			}
			return result;
        },
        placesMaps() {
            const acUbicacion = this.$refs["acUbicacion"];
            let autocomplete = new google.maps.places.Autocomplete(acUbicacion, {
                fields: ["address_components", "name", "formatted_address", "geometry", "url"] // especificando los parametros a usar se reduce el costo de uso del API
            });
            autocomplete.inputId = acUbicacion.id;
            google.maps.event.addListener(autocomplete, 'place_changed', () => {
                let place = autocomplete.getPlace();
                let placeData = this.convertPlaceToFriendlyObject(place);
                this.evento.longitud = placeData.lng.toString();
                this.evento.latitud = placeData.lat.toString();
                this.evento.urlMapa = placeData.mapUrl;
                this.evento.lugar = placeData.name; 
                this.evento.direccion = placeData.formattedAddress;
            });
        },
        agregarSubevento() {
            let subEventoObj = { 
                nombre:'',  
                costo: 0,
                cupoMaximo: 0,
                permiteCancelar: 0,
                permiteCheckOut: 0,
                eventoVirtual: 0               
            };
            if (this.id > 0) {
                subEventoObj.idEvento = this.id;
            }
            this.subeventos.push(subEventoObj);
        },
        eliminarSubEvento(subevento) {
            const index = this.subeventos.indexOf(subevento);
            if (index > -1) {
                this.subeventos.splice(index, 1);
            }
        },
        obtenerEvento() {
           
            this.isLoading = true;
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/eventos/' + this.id, {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                   
                    this.evento = response.data.data;
                    if (this.evento.compartidos) {
                        this.evento.compartidos.map((item) => {
                            this.campusSelected.push({
                                value: item.campus_id,
                                label: item.campus.nombre
                            });
                        });
                    }

                    if (this.evento.calificaciones && this.evento.calificaciones.length > 0) {
                        this.evento.calificaciones.map((x) => {
                            this.calificaciones.push({
                                ...x,
                                name: x.name,
                                elements: JSON.parse(x.metadata)
                            });

                        });

                        this.elementosCalificados = Object.keys(this.calificaciones[0].elements);
                    }

                    this.editores = this.evento.editores ? [...this.evento.editores]: [];
                    if (!this.previousEventData.id)
                    this.previousEventData = {...this.evento};

                    if (this.authData.user.idPerfil == 1) {
                        this.obtenerCatalogos();
                    }
                    this.obtenerSubEventos();
                    this.isLoading = false;
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerSubEventos() {
            this.$AuthApiService.getAccessToken().then(r => 
                this.$axios.get(this.basePath + 'api/subeventos/' + this.id + '/evento', {
                    headers: { 'Authorization': r.token_type + ' ' + r.access_token }
                })
                .then(response => {
                    this.subeventos = response.data.data;
                })
                .catch(error => {
                    console.log(error.response);
                })
            );
        },
        obtenerCatalogos() {
            this.campusParam = '&idCampus=' + this.evento.idCampus;
            this.obtenerAreas();
            this.obtenerTiposDeEvento();
            this.obtenerCategoriasEvento();
            this.obtenerFormasDePagoEvento();
            this.obtenerCampus();
        },
        makeReadable(value) {
            return value.replaceAll(/_/g,' ');
        },
        fetchData() {
            let data = [];
            for (const calificacion of this.calificaciones) {
                let aux = {};
                aux['name'] = calificacion.name;
                aux['rating'] = calificacion.rating;
                for (const key of this.elementosCalificados) {
                    aux[key] = calificacion.elements[key];
                }
                data.push(aux);
            }
            return data;
        },
        fetchFields() {
            let fields = {

            };

            fields['NOMBRE'] = "name";
            fields['CALIFICACION'] = "rating";

            for (const key of this.elementosCalificados) {
                fields[this.makeReadable(key).toUpperCase()] = key;
            }
            return fields;
        },
        startDownload(){
            this.isLoading = true;
        },
        finishDownload(){
            this.isLoading = false;
        },
    },
    mounted() {
        this.evento.idCampus = this.authData.user.idCampus;
        this.campusParam = '&idCampus=' + this.evento.idCampus;
        if (this.authData.user.idPerfil == 1) {
            this.evento.idCampus = '';
            this.obtenerCampus();
        }
        this.id = this.$route.params.id;
        if (this.id > 0) {
            this.obtenerEvento();
        }
        this.obtenerCatalogos();
        this.placesMaps(); 
    }
}
</script>
